import React, { ReactNode } from 'react';
import { Chip } from '@material-ui/core';

export type StatusType = {
  status: ReactNode;
  bgcolor: string;
  tiny?: boolean;
};

const StatusChip = ({ status, bgcolor, tiny }: StatusType) => (
  <Chip
    size='small'
    label={status}
    style={{
      borderRadius: 5,
      color: 'white',
      background: bgcolor,
      fontSize: !tiny ? 'inherit' : '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
    }}
  />
);

const StatusChipSmall = ({ status, bgcolor }: StatusType) => (
  <Chip
    size='small'
    label={status}
    style={{
      borderRadius: 5,
      opacity: 0.7,
      color: 'white',
      fontSize: '7px',
      background: bgcolor,
      fontWeight: 600,
      padding: '2px !important',
      textTransform: 'uppercase',
      marginLeft: '5px',
    }}
  />
);

export { StatusChip, StatusChipSmall };
